import { Link } from "react-router-dom";
import { FaFacebook, FaPhoneVolume } from "react-icons/fa6";
import { FaInstagramSquare } from "react-icons/fa";
import { FaSquareYoutube } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
function Footer() {
  return (
    <footer>
      <div className="footer">
        <ul>
          <li className="title-footer">
            <div>
              <h1>SGMR Pharmaceuticals Private Limited</h1>
              <ul>
                <li>
                  <FaFacebook />
                  <a
                    href="https://www.facebook.com/sgmrpharma"
                    target="_black"
                  ></a>
                </li>
                <li>
                  <FaInstagramSquare />
                  <a
                    href="https://www.linkedin.com/in/sgmr-pharmaceuiticals-5391b1114"
                    target="_black"
                  ></a>
                </li>
                <li>
                  <FaSquareYoutube />
                  <a href="https://twitter.com/sgmr_pharma" target="_black"></a>
                </li>

                <li>
                  <FaXTwitter />
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div className="footer-item">
              <h4>Important links</h4>
              <ul>
                <Link to="/home">Home</Link>
                <Link to="/products">Products</Link>
                <Link to="/research">R&D</Link>
                <Link to="/globalpre">Global Presence</Link>
                <Link to="/contact">Contact Us</Link>
                <Link to="/infrastructure">Infrastructure</Link>
              </ul>
            </div>
          </li>
          <li className="footer-address">
            <h4>Our Address:</h4>
            <div>
              <p>
                {" "}
                <strong>
                  <FaLocationDot size={20} />
                  India:
                </strong>{" "}
                MIG Block No. 89, Phase-III, Jntu Hitech city Road, Kphb,
                Hyderabad - 500072 Telangana India
              </p>
              {/* <p>
                {" "}
                <strong>
                  <FaLocationDot size={20} />
                  UAE:{" "}
                </strong>{" "}
                Capital Golden Tower - Office 906, Business Bay - Dubai United
                Arab Emirates
              </p> */}
              {/* <p>
                {" "}
                <strong>
                  <FaLocationDot size={20} />
                  UK:
                </strong>{" "}
                Appt. 615 Jefferson Place 1 Fernie Street, Manchester, United
                Kingdom, M4 4BL
              </p> */}
            </div>
          </li>
          <li className="footer-contact">
            <h4>Contact Us</h4>
            <div>
              <p>
                <strong>
                  <FaPhoneVolume size={15} />
                </strong>{" "}
                +9140-23061889 , +91-9032001889
              </p>
              <p>
                <strong>
                  <FaPhoneVolume size={15} />
                </strong>{" "}
                +971585396686, +971585631889
              </p>

              <p>
                <strong>
                  <IoMail size={20} />
                </strong>{" "}
                sales@sgmrpharma.com
              </p>

              <p>
                <strong>
                  <IoMail size={20} />
                </strong>{" "}
                purchase@sgmrpharma.com
              </p>

              <p>
                <strong>
                  <IoMail size={20} />
                </strong>
                api.marketing@sgmrpharma.com
              </p>

              {/* <p>
                <strong><IoMail size={20}/></strong> api.sales@gmrpharma.com
              </p>
              <p>
                <strong><IoMail size={20}/></strong> api.purchase@gmrpharma.com 
              </p> */}
            </div>
          </li>
        </ul>
      </div>
      <p className="copyright-div">
        <div className="copyright">
          SGMR Pharmaceuticals Private Limited © 2025 | All Rights Reserved
        </div>
        <div className="copyright">
          Designed and Developed by{" "}
          <a href="https://www.acetians.com/" target="_blank">
            Acetians Technologies pvt. ltd.
          </a>
        </div>
      </p>
    </footer>
  );
}

export default Footer;
